import { useTablesStyles } from "@/pages/shift-report/styles/useTablesStyles";
import { Entry } from "@dexteel/mesf-core";
import { Box, Paper } from "@mui/material";
import { GridApi, GridReadyEvent } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useState } from "react";
import { useTableData } from "./hooks/useTableData";

interface Props {
	rows: Entry[];
	isLoading: boolean;
}

export const LogbookTable = ({ rows, isLoading }: Props) => {
	const classes = useTablesStyles();
	const { columns } = useTableData();
	const [gridAPI, setGridAPI] = useState<GridApi | null>(null);

	const onGridReady = (params: GridReadyEvent) => {
		setGridAPI(params.api);
	};
	useEffect(() => {
		if (gridAPI) {
			if (isLoading) gridAPI.showLoadingOverlay();
			else gridAPI.hideOverlay();
		}
	}, [gridAPI, isLoading]);

	return (
		<Paper elevation={0}>
			<Box className={`${classes.smAgGridBox} ${classes.dynamicHeight}`}>
				<AgGridReact
					rowSelection="single"
					suppressRowClickSelection={true}
					pagination={false}
					singleClickEdit={false}
					tooltipShowDelay={0}
					tooltipHideDelay={2000}
					rowData={rows}
					columnDefs={columns}
					onGridReady={onGridReady}
				/>
			</Box>
		</Paper>
	);
};
